import { useMediaQuery } from "@/customHooks/useMediaQuery";
import { IoNotificationsOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "../Core/Button";
import Logo from "../Logo";
import ProfileDetailsComponent from "../ProfileComponent";
import Classes from "./AfterLoginHeader.module.css";

export const AfterLoginHeader = ({ drawerBtn }) => {
  const { user } = useSelector((state) => state?.authReducer);
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 992px)");
  const { unReadNotificationCount } = useSelector(
    (state) => state?.commonReducer
  );
  return (
    <div className={Classes.loginHeader}>
      <div className={Classes.navbarContainer}>
        {drawerBtn && drawerBtn}
        <div className={Classes.headerLeft}>
          {!isMobile && (
            <div
              className={Classes?.logoContainer}
              onClick={() => navigate("/")}
            >
              <Logo
                variant={"logo"}
                type={"header"}
                disableMobileChange={true}
              />
            </div>
          )}
        </div>
        <div className={Classes.headerRight}>
          <div
            className={Classes.notification_header}
            onClick={() => navigate("/notifications")}
          >
            <Button
              size="sm"
              variant="bordered"
              className={Classes.notificationBtn}
            >
              {unReadNotificationCount > 0 && (
                <div className={Classes.unreadNotification}>
                  {unReadNotificationCount > 9 ? "9+" : unReadNotificationCount}
                </div>
              )}
              <IoNotificationsOutline size={24} color="var(--icon-color)" />
            </Button>
          </div>
          <ProfileDetailsComponent user={user} />
        </div>
      </div>
    </div>
  );
};
